import { FC, ReactNode, useRef } from 'react';
import './MyModal.css';

interface MyModalProps {
    children: ReactNode;
    visible: boolean;
    setVisible: (visible: boolean) => void;
    width?: string;
    height?: string;
}

const MyModal: FC<MyModalProps> = ({ children, visible, setVisible, width, height }) => {
    const rootClasses = ['myModal'];
    const modalContentRef = useRef<HTMLDivElement>(null);

    const styles = {
        ...(width && { width: `${width}` }),
        ...(height && { height: `${height}` }),
    };
    
    if (visible) {
        rootClasses.push('active');
    }
    
    const handleClickOutside = (event: React.MouseEvent<HTMLDivElement>) => {
        if (modalContentRef.current && !modalContentRef.current.contains(event.target as Node)) {
            setVisible(false);
        }
    };
    
    return (
        <div className={rootClasses.join(' ')} onMouseDown={handleClickOutside}>
            <div
                className="myModalContent"
                ref={modalContentRef} 
                onMouseDown={(e) => e.stopPropagation()}
                style={styles}
            >
                {children}
            </div>
        </div>
    );
};

export default MyModal;